import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import usJSON from './locale/US.json';  // 한국어 번역 파일 추가

// 시스템 언어 확인 및 기본 언어 설정
const systemLanguage = navigator.language || navigator.userLanguage;
const defaultLanguage = systemLanguage.toLowerCase().startsWith('ko') ? 'ko' : 'en';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      ...usJSON,
    },
  },
  lng: defaultLanguage,  // 기본 언어 설정
  fallbackLng: 'ko',    // 번역이 없을 경우 영어로 폴백
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
